import React, { useEffect, useState } from 'react'
import { stanjeLageraPanelaPartnera } from '../../api/proizvodnja'

const PartneriDashboard = () => {

    const [loading, setLoading] = useState(true)

    const [stats, setStats] = useState({
        nalozi_za_proizvest: 0,
        suma_zavrsena: 0,
        suma_za_isporucit: 0,
    })

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {

        try {

            setLoading(true)

            const data = await stanjeLageraPanelaPartnera(223285)

            setStats(data)

        } catch (error) {

            console.error(error)

        } finally {

            setLoading(false)
        }
    }

    const cards = [
        {
            title: 'Nalozi za proizvodnju',
            value: stats.nalozi_za_proizvest,
            icon: 'ki-outline ki-package',
            color: 'primary',
            subtitle: 'Ukupna količina u proizvodnji',
        },
        {
            title: 'Završena proizvodnja',
            value: stats.suma_zavrsena,
            icon: 'ki-outline ki-check-circle',
            color: 'success',
            subtitle: 'Ukupno završeno panela',
        },
        {
            title: 'Za isporučiti',
            value: stats.suma_za_isporucit,
            icon: 'ki-outline ki-delivery-3',
            color: 'warning',
            subtitle: 'Spremno za isporuku',
        },
    ]

    return (
        <div className='container-fluid'>
            <div className='row g-5 g-xl-8'>

                {cards.map((card, index) => (

                    <div className='col-xl-4' key={index}>

                        <div
                            className={`card card-xl-stretch mb-xl-8 border-0 shadow-sm bg-light-${card.color}`}
                            style={{
                                borderRadius: '20px',
                                overflow: 'hidden',
                                position: 'relative',
                            }}
                        >

                            <div className='card-body p-8'>

                                <div className='d-flex align-items-center justify-content-between mb-6'>

                                    <div
                                        className={`symbol symbol-70px bg-${card.color}`}
                                        style={{
                                            borderRadius: '18px',
                                        }}
                                    >
                                        <i className={`${card.icon} fs-1 text-white`}></i>
                                    </div>

                                    <div
                                        className={`badge badge-light-${card.color} fw-bold px-4 py-3`}
                                    >
                                        Alternativa 1997
                                    </div>

                                </div>

                                <div className='mb-2'>

                                    <div className='text-dark fw-bolder fs-2hx'>

                                        {loading
                                            ? '...'
                                            : Number(card.value).toLocaleString()
                                        }

                                    </div>

                                </div>

                                <div className='fw-bold fs-3 text-gray-800 mb-2'>
                                    {card.title}
                                </div>

                                <div className='text-gray-600 fw-semibold fs-6'>
                                    {card.subtitle}
                                </div>

                                <div
                                    className='position-absolute opacity-10'
                                    style={{
                                        right: '-10px',
                                        bottom: '-15px',
                                        fontSize: '130px',
                                    }}
                                >
                                    <i className={`${card.icon} text-${card.color}`}></i>
                                </div>

                            </div>

                        </div>

                    </div>

                ))}

            </div>

            <div className='row g-5 mt-2'>

                <div className='col-12'>

                    <div
                        className='card shadow-sm border-0'
                        style={{ borderRadius: '20px' }}
                    >

                        <div className='card-body p-10'>

                            <div className='d-flex align-items-center justify-content-between flex-wrap'>

                                <div>

                                    <h2 className='fw-bolder text-dark mb-2'>
                                        Pregled lagera panela partnera!
                                    </h2>

                                    <div className='text-muted fw-semibold fs-6'>
                                        Real-time pregled proizvodnje, lagera i isporuke panela.
                                    </div>

                                </div>

                                <div className='mt-5 mt-md-0'>

                                    <button
                                        className='btn btn-primary btn-lg fw-bold'
                                        onClick={fetchData}
                                    >
                                        <i className='ki-outline ki-arrows-circle fs-2 me-2'></i>

                                        Osvježi podatke
                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default PartneriDashboard